module.exports = __webpack_public_path__ + "img/d4.435c2f16.svg";